import React from "react";

const onlineDotIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="5" fill="#42C414" />
      <g filter="url(#filter0_f_55_495)">
        <circle cx="8" cy="8" r="6.5" stroke="#42C414" />
      </g>
      <defs>
        <filter
          id="filter0_f_55_495"
          x="0"
          y="0"
          width="16"
          height="16"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.5"
            result="effect1_foregroundBlur_55_495"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default onlineDotIcon;
